import { Modal } from 'tailwindcss-stimulus-components'
import * as Turbo from '@hotwired/turbo'
import Swal from 'sweetalert2'
export default class ExtendedModal extends Modal {
  static targets = ['cancel_form', 'approve_form', 'attachment_form']

  connect () {
    super.connect()
  }

  handleSuccess ({ detail: { success } }) {
    if (success) {
      super.close()
      if (this.formTarget) this.formTarget.reset()
    }
  }

  async handleSuccessRedirect (event) {
    if (event.detail.success) {
      super.close()
      if (this.formTarget) this.formTarget.reset()
      await new Promise(resolve => setTimeout(resolve, 100)) // Swalが表示されるまでのクッション
      const modal = await Swal.fire({
        icon: 'success',
        title: 'ご登録ありがとうございます',
        text: '数分以内に確認メールが送信されます',
        confirmButtonText: '戻る',
        confirmButtonColor: '#40BF6C',
        reverseButtons: true,
        allowOutsideClick: false
      })
      if (modal.isConfirmed) {
        Turbo.visit(event.detail.fetchResponse.response.url)
      }
    }
  }

  open (e) {
    if (this.preventDefaultActionOpening) {
      e.preventDefault()
    }

    if (e.target.blur) {
      e.target.blur()
    }

    // Lock the scroll and save current scroll position
    // モーダルの表示と背景が崩れるためコメントアウト
    // https://github.com/excid3/tailwindcss-stimulus-components/issues/136
    // this.lockScroll()

    // Unhide the modal
    this.containerTarget.classList.remove(this.toggleClass)

    // Insert the background
    if (!this.data.get('disable-backdrop')) {
      document.body.insertAdjacentHTML('afterbegin', this.backgroundHtml)
      this.background = document.querySelector(`#${this.backgroundId}`)
    }
  }

  clearErrors () {
    if (this.hasErrorsTarget) {
      this.errorsTarget.remove()
    }
  }
}
